import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import "./AddressDoctorModal.scss";
import { addressFormat, handleMilitaryState } from "../ComboCode/ComboCodeUtility";

var AddressDoctorModal = /*#__PURE__*/function (_Component) {
  _inherits(AddressDoctorModal, _Component);

  function AddressDoctorModal(props) {
    var _this;

    _classCallCheck(this, AddressDoctorModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddressDoctorModal).call(this, props));
    window.addEventListener("keydown", function (event) {
      if (_this.props.modalVisibility) {
        var modal = document.querySelector('#ad-modal');
        var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        var firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
        var focusableContent = modal.querySelectorAll(focusableElements);
        var lastFocusableElement = focusableContent[focusableContent.length - 1];
        var activeElement = window.document.activeElement;

        if (event.shiftKey && event.key === 'Tab') {
          if (activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            event.preventDefault();
          }
        } else if (event.key === 'Tab') {
          if (activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            event.preventDefault();
          }
        }
      }
    });
    return _this;
  }

  _createClass(AddressDoctorModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.modalVisibility) {
        setTimeout(function () {
          document.querySelector("#ad-modal-close button").focus();
        }, 200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(Modal, {
        show: this.props.modalVisibility,
        id: "ad-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        id: "ad-modal-close",
        onClick: this.props.closeModal
      }, /*#__PURE__*/React.createElement(Modal.Title, null, "Confirm your address")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("p", {
        className: "description"
      }, "Please select the address you'd like to use."), this.props.recommendedAddress.slice(0, 3).map(function (addressObjectMapped, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "address-option",
          key: index
        }, /*#__PURE__*/React.createElement("p", null, addressFormat(addressObjectMapped.addressLine1), /*#__PURE__*/React.createElement("br", null), addressFormat(addressObjectMapped.city), /*#__PURE__*/React.createElement("br", null), addressObjectMapped.stateOrProvince, " ", addressObjectMapped.postalCode, /*#__PURE__*/React.createElement("br", null), addressFormat(addressObjectMapped.country), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Button, {
          variant: "secondary",
          className: "blue-btn address-button",
          onClick: function onClick(event) {
            _this2.props.updateShippingForm(addressFormat(addressObjectMapped.addressLine1), addressFormat(addressObjectMapped.city), addressObjectMapped.postalCode, addressObjectMapped.isoCountry, handleMilitaryState(_this2.props.userEnteredAddress.stateOrProvince, addressObjectMapped.stateOrProvince), addressFormat(addressObjectMapped.country));
          }
        }, "Use recommended"));
      }), /*#__PURE__*/React.createElement("p", {
        className: "yourad"
      }, "Your address"), /*#__PURE__*/React.createElement("div", {
        className: "address-option"
      }, /*#__PURE__*/React.createElement("p", null, this.props.userEnteredAddress.addressLine1, " ", this.props.addressLine2, /*#__PURE__*/React.createElement("br", null), this.props.userEnteredAddress.city, /*#__PURE__*/React.createElement("br", null), this.props.userEnteredAddress.stateOrProvince, " ", this.props.userEnteredAddress.postalCode, /*#__PURE__*/React.createElement("br", null), this.props.userEnteredAddress.country, /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Button, {
        variant: "secondary",
        className: "white-btn address-button last-button",
        onClick: function onClick() {
          var matchFound = _this2.props.recommendedAddress.some(function (address) {
            if (address.postalCode === _this2.props.userEnteredAddress.postalCode) {
              return true;
            }

            return false;
          });

          if (matchFound) {
            _this2.props.handleFormSubmit();
          } else {
            _this2.props.closeModal();

            _this2.props.handleAddressValidateAlertVisibility();
          }
        }
      }, "Use your address"))));
    }
  }]);

  return AddressDoctorModal;
}(Component);

export { AddressDoctorModal as default };